import React, { Component } from 'react';
import { connect } from 'react-redux';
import classnames from 'classnames';
import { cloneDeep, get, isEmpty, isEqual, map, forEach } from 'lodash';
import { Tree as AntTree } from 'antd';
import { TreeProps as AntTreeProps } from 'antd/lib/tree';
import { Spin as AntSpin } from 'antd';
import { load } from '@comall-backend-builder/core/lib/loaders';
import { ICategoryTree } from '../../interfaces';
import { CustomStyleComponentProps } from '@comall-backend-builder/components-basis';

const AntTreeNode = AntTree.TreeNode;

function formatTreeData(treeData: ICategoryTree[]): any {
    return map(treeData, (val) => {
        const { id, name, childrenNode } = val;
        return {
            key: id + '',
            title: name,
            children: childrenNode ? formatTreeData(childrenNode) : [],
        };
    });
}
export interface CategoryLinkageTreeProps extends CustomStyleComponentProps {
    treeData: ICategoryTree[];
    onSelect: (id: number) => void;
}

class categoryLinkageTree extends Component<CategoryLinkageTreeProps, never> {
    constructor(props: any) {
        super(props);
        this.onSelect = this.onSelect.bind(this);
    }

    renderTreeNodes(data: any) {
        return map(data, (item) => {
            const children = item.children;
            const props = {
                key: item.id,
                title: item.name,
            };
            return <AntTreeNode {...props}>{children}</AntTreeNode>;
        });
    }

    onSelect(key: string[]) {
        if (key.length < 1) return;
        const { onSelect } = this.props;
        onSelect(parseInt(key[0]));
    }

    render() {
        const { className, treeData } = this.props;
        const formatOptions = formatTreeData(treeData);
        const defaultExpandedKeys = map(formatOptions, 'key');

        return (
            <div className={classnames(className, 'category-linkage-tree')}>
                <AntSpin spinning={isEmpty(treeData)}>
                    {!isEmpty(treeData) ? (
                        <AntTree
                            treeData={formatOptions}
                            defaultExpandedKeys={defaultExpandedKeys}
                            onSelect={this.onSelect}
                        >
                            {this.renderTreeNodes(treeData)}
                        </AntTree>
                    ) : null}
                </AntSpin>
            </div>
        );
    }
}

function mapStateToProps(state: any, props: any) {
    const { entity, componentId } = props;
    const metainfo = entity.metainfo;

    return {
        metainfo,
        componentId,
        requestStatus: entity.requestStatus,
        treeData: entity.fields,
    };
}

export const CategoryLinkageTree = connect(mapStateToProps)(categoryLinkageTree);
